<template>
  <div class="a">
    <Nav/>
    <SwiperHome/>
    <HomeService/>
    <HomeSolution/>
    <HomePartners/>
    <Contact/>
    <Footer/>
  </div>
</template>

<script>
import Nav from '@/components/Nav'
import SwiperHome from '@/components/SwiperHome'
import HomeService from '@/components/HomeService'
import HomeSolution from '@/components/HomeSolution'
import HomePartners from '@/components/HomePartners'
import Contact from '@/components/Contact'
import Footer from '@/components/Footer'
export default {
  name: '',
  components: {
    Nav,
    SwiperHome,
    HomeService,
    HomeSolution,
    HomePartners,
    Contact,
    Footer
  },
  data () {
    return {
      
    }
  }
}
</script>

<style scoped lang="less">
.a{
  .b{
    font-size: 30px;
  }
}
</style>
